export default __webpack_public_path__ + "static/media/background_picture2@2x.55f50f2c.png";